var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.47 5.054a.75.75 0 0 1 1.06 0l3.333 3.333a.75.75 0 0 1 0 1.06L4.53 12.781a.75.75 0 0 1-1.06-1.06l2.802-2.804L3.47 6.114a.75.75 0 0 1 0-1.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.137 5.054a.75.75 0 0 1 1.06 0l3.333 3.333a.75.75 0 0 1 0 1.06l-3.333 3.334a.75.75 0 0 1-1.06-1.06l2.802-2.804-2.802-2.803a.75.75 0 0 1 0-1.06"
  })));
};
export default Svg16;